import React, { Component } from "react";
import MetaTags from 'react-meta-tags';
import { translate } from "react-i18next";
import { Link } from "react-router-dom";
import './home.css';

import say_play_btn from '../../image/home/say_play_btn.png';
import conf_icon from '../../image/home/conf_icon.png';
import comp_icon from '../../image/home/comp_icon.png';
// import Timer from "../widget/timer";
import Rolling from "../widget/rolling";
import org_1 from '../../image/home/partners_logos/1a_website_logo_org_emsd.jpg';
import org_2 from '../../image/home/partners_logos/1b_website_logo_org_gdtech.jpg';
import adv_1 from '../../image/home/partners_logos/2a_website_logo_adv_itr.jpg';
import adv_2 from '../../image/home/partners_logos/2b_website_logo_adv_ctech.jpg';
import coorg_1 from '../../image/home/partners_logos/3a_website_logo_coorg_acm.jpg';
import coorg_2 from '../../image/home/partners_logos/3b_website_logo_coorg_sig.jpg';
import coorg_3 from '../../image/home/partners_logos/3c_website_logo_coorg_aee.jpg';
import coorg_4 from '../../image/home/partners_logos/3d_website_logo_coorg_anebc.jpg';
import coorg_5 from '../../image/home/partners_logos/3e_website_logo_coorg_ashrae.jpg';
import coorg_6 from '../../image/home/partners_logos/3f_website_logo_coorg_bacnet.jpg';
import coorg_7 from '../../image/home/partners_logos/3g_website_logo_coorg_cibse.jpg';
import coorg_8 from '../../image/home/partners_logos/3h_website_logo_coorg_cyberport.jpg';
import coorg_9 from '../../image/home/partners_logos/3i_website_logo_coorg_hkstp.jpg';
import coorg_10 from '../../image/home/partners_logos/3j_website_logo_coorg_ieee.jpg';
import coorg_11 from '../../image/home/partners_logos/3k_website_logo_coorg_ogcio.jpg';
import coorg_12 from '../../image/home/partners_logos/3l_website_logo_coorg_wgbc.jpg';
import coorg_13 from '../../image/home/partners_logos/3m_website_logo_coorg_gdca.jpg';
import sup_1 from '../../image/home/partners_logos/4a_website_logo_sup_asd.jpg';
import sup_2 from '../../image/home/partners_logos/4b_website_logo_sup_ashhkchp.jpg';
import sup_3 from '../../image/home/partners_logos/4c_website_logo_sup_beam.jpg';
import sup_4 from '../../image/home/partners_logos/4d_website_logo_sup_bsomes.jpg';
import sup_5 from '../../image/home/partners_logos/4e_website_logo_sup_bec.jpg';
import sup_6 from '../../image/home/partners_logos/4f_website_logo_sup_cityuhk.jpg';
import sup_7 from '../../image/home/partners_logos/4g_website_logo_sup_eihk.jpg';
import sup_8 from '../../image/home/partners_logos/4h_website_logo_sup_ive.jpg';
import sup_9 from '../../image/home/partners_logos/4i_website_logo_sup_hkabaeima.jpg';
import sup_10 from '../../image/home/partners_logos/4j_website_logo_sup_hkastri.jpg';
import sup_11 from '../../image/home/partners_logos/4k_website_logo_sup_hkbs.jpg';
import sup_12 from '../../image/home/partners_logos/4l_website_logo_sup_hkcs.jpg';
import sup_13 from '../../image/home/partners_logos/4m_website_logo_sup_hkgbc.jpg';
import sup_14 from '../../image/home/partners_logos/4n_website_logo_sup_hkiota.jpg';
import sup_15 from '../../image/home/partners_logos/4o_website_logo_sup_hkpc.jpg';
import sup_16 from '../../image/home/partners_logos/4p_website_logo_sup_lscm.jpg';
import sup_17 from '../../image/home/partners_logos/4q_website_logo_sup_scc.jpg';
import sup_18 from '../../image/home/partners_logos/4r_website_logo_sup_taeehk.jpg';
import sup_19 from '../../image/home/partners_logos/4s_website_logo_sup_tcibsehk.jpg';
import sup_20 from '../../image/home/partners_logos/4t_website_logo_sup_tcuhk.jpg';
import sup_21 from '../../image/home/partners_logos/4u_website_logo_sup_thkfemc.jpg';
import sup_22 from '../../image/home/partners_logos/4v_website_logo_sup_thkiebsd.jpg';
import sup_23 from '../../image/home/partners_logos/4w_website_logo_sup_thkieed.jpg';
import sup_24 from '../../image/home/partners_logos/4x_website_logo_sup_thkieged.jpg';
import sup_25 from '../../image/home/partners_logos/4y_website_logo_sup_thkieitd.jpg';
import sup_26 from '../../image/home/partners_logos/4z_website_logo_sup_thkpu.jpg';
import sup_27 from '../../image/home/partners_logos/4z2_website_logo_sup_thkust.jpg';
import sup_28 from '../../image/home/partners_logos/4z3_website_logo_sup_tiet.jpg';
import sup_29 from '../../image/home/partners_logos/4z4_website_logo_sup_thku.jpg';
import sup_30 from '../../image/home/partners_logos/4z5_website_logo_sup_hkbu.jpg';
import sup_31 from '../../image/home/partners_logos/4z6_website_logo_sup_HKIS.jpg';
import dia_1 from '../../image/home/partners_logos/5a_website_logo_diamond_Alliance.jpg';
import dia_2 from '../../image/home/partners_logos/5b_website_logo_diamond_anlev.jpg';
import dia_3 from '../../image/home/partners_logos/5c_website_logo_diamond_atal.jpg';
import dia_4 from '../../image/home/partners_logos/5d_website_logo_diamond_aws.jpg';
import dia_5 from '../../image/home/partners_logos/5e_website_logo_diamond_huawei.jpg';
import dia_6 from '../../image/home/partners_logos/5f_website_logo_diamond_ms.jpg';
import dia_7 from '../../image/home/partners_logos/5g_website_logo_diamond_siemens.jpg';
import dia_8 from '../../image/home/partners_logos/5h_website_logo_diamond_sino.jpg';
import dia_9 from '../../image/home/partners_logos/5i_website_logo_diamond_tencent.jpg';
import dia_10 from '../../image/home/partners_logos/5j_website_logo_diamond_towngas.jpg';
import dia_11 from '../../image/home/partners_logos/5k_website_logo_diamond_yord.jpg';
import plat_1 from '../../image/home/partners_logos/6a_website_logo_Platinum_che.jpg';
import plat_2 from '../../image/home/partners_logos/6b_website_logo_Platinum_clp.jpg';
import plat_3 from '../../image/home/partners_logos/6c_website_logo_Platinum_fse.jpg';
import plat_4 from '../../image/home/partners_logos/6d_website_logo_Platinum_hkbn.jpg';
import plat_5 from '../../image/home/partners_logos/6e_website_logo_Platinum_kone.jpg';
import plat_6 from '../../image/home/partners_logos/6f_website_logo_Platinum_mv.jpg';
import plat_7 from '../../image/home/partners_logos/6g_website_logo_Platinum_mtr.jpg';
import plat_8 from '../../image/home/partners_logos/6h_website_logo_Platinum_arup.jpg';
import plat_9 from '../../image/home/partners_logos/6i_website_logo_Platinum_recg.jpg';
import plat_10 from '../../image/home/partners_logos/6j_website_logo_Platinum_hke.jpg';
import plat_11 from '../../image/home/partners_logos/6k_website_logo_Platinum_veolia.jpg';
import plat_12 from '../../image/home/partners_logos/6l_website_logo_Platinum_WSP.jpg';
import plat_13 from '../../image/home/partners_logos/6m_website_logo_Platinum_cmobile.jpg';
import gold_1 from '../../image/home/partners_logos/7a_website_logo_Gold_fujitec.jpg';
import gold_2 from '../../image/home/partners_logos/7b_website_logo_Gold_jec.jpg';
import gold_3 from '../../image/home/partners_logos/7c_website_logo_Gold_ke.jpg';
import gold_4 from '../../image/home/partners_logos/7d_website_logo_Gold_newtech.jpg';
import gold_5 from '../../image/home/partners_logos/7e_website_logo_Gold_schdl.jpg';
import gold_6 from '../../image/home/partners_logos/7f_website_logo_Gold_shk.jpg';
import gold_7 from '../../image/home/partners_logos/7g_website_logo_Gold_sc.jpg';
import gold_8 from '../../image/home/partners_logos/7h_website_logo_Gold_delta.jpg';
import Footer from "../layout/footer";

class Home extends Component {
  state = {
    topVideoUrl: "",
    topVideoUpdate: false,
    slided: false,
  }
  goToTop() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "initial"
    });
  }
  updateVideo(type) {
    let path = window.location.pathname
    path = path.slice(1, 3);
    let videoSrc;
    if (type === 'org_1') {
      if (path === 'en') {
        videoSrc = 'https://storage.googleapis.com/emsd_video/Organizer_EMSD_Pang%20Yiu%20Hung_English_20210928_FINAL.mp4';
      } else if (path === 'sc') {
        videoSrc = 'https://storage.googleapis.com/emsd_video/EMSD_SC.mp4';
      } else if (path === 'tc') {
        videoSrc = 'https://storage.googleapis.com/emsd_video/EMSD_TC.mp4';
      }
    } else if (type === 'org_2') {
      if (path === 'en') {
        videoSrc = 'https://storage.googleapis.com/emsd_video/Organizer_%E5%BB%A3%E7%A7%91%E5%8D%94_Eng_v3.mp4';
      } else if (path === 'sc') {
        videoSrc = 'https://storage.googleapis.com/emsd_video/%E5%BB%A3%E7%A7%91%E5%8D%94_SC.mp4';
      } else if (path === 'tc') {
        videoSrc = 'https://storage.googleapis.com/emsd_video/%E5%BB%A3%E7%A7%91%E5%8D%94_TC.mp4';
      }
    } else if (type === 'adv_1') {
      if (path === 'en') {
        videoSrc = 'https://storage.googleapis.com/emsd_video/Advisors_ITB_MrSit_English_20210928_FINAL.mp4';
      } else if (path === 'sc') {
        videoSrc = 'https://storage.googleapis.com/emsd_video/ITB_SC.mp4';
      } else if (path === 'tc') {
        videoSrc = 'https://storage.googleapis.com/emsd_video/ITB_TC.mp4';
      }
    } else if (type === 'adv_2') {
      if (path === 'en') {
        videoSrc = 'https://storage.googleapis.com/emsd_video/Advisors_%E4%B8%AD%E7%A7%91%E5%8D%94_Eng_v3.mp4';
      } else if (path === 'sc') {
        videoSrc = 'https://storage.googleapis.com/emsd_video/%E4%B8%AD%E7%A7%91%E5%8D%94_SC.mp4';
      } else if (path === 'tc') {
        videoSrc = 'https://storage.googleapis.com/emsd_video/%E4%B8%AD%E7%A7%91%E5%8D%94_TC.mp4';
      }
    }
    let video = document.getElementById('video');

    video.setAttribute('src', videoSrc + "?autoPlay=1&amp;modestbranding=1&amp;showinfo=0");
  }
  updateTopVideo() {
    let width = window.innerWidth;
    let path = window.location.pathname
    path = path.slice(1, 3);

    if (width > 768) {
      if (path === 'en') {
        this.setState({ topVideoUrl: "https://storage.googleapis.com/emsd_video/WOW_EMSD_AI_Online_Teaser_ENG_20210930_1080.mp4" });
      } else if (path === 'sc') {
        this.setState({ topVideoUrl: "https://storage.googleapis.com/emsd_video/EMSD_GlobalAIChallenge_Teaser_SC_compressed.mp4" });
      } else if (path === 'tc') {
        this.setState({ topVideoUrl: "https://storage.googleapis.com/emsd_video/EMSD_GlobalAIChallenge_Teaser_TC_compressed.mp4" });
      }
    } else {
      if (path === 'en') {
        this.setState({ topVideoUrl: "https://storage.googleapis.com/emsd_video/WOW_EMSD_AI_Online_Teaser_ENG_20210930_360.mp4" });
      } else if (path === 'sc') {
        this.setState({ topVideoUrl: "https://storage.googleapis.com/emsd_video/WOW_EMSD_AI_Online_Teaser_SC_20211007_360.mp4" });
      } else if (path === 'tc') {
        this.setState({ topVideoUrl: "https://storage.googleapis.com/emsd_video/WOW_EMSD_AI_Online_Teaser_TC_20211006_360.mp4" });
      }
    }
    document.getElementById('topVideo').loop = false;
    document.getElementById('topVideo').controls = true;
    document.getElementById('topVideo').muted = false;
    document.getElementById('topVideo').autoPlay = true;
    this.setState({ topVideoUpdate: true });

  }

  componentDidMount() {
    let path = window.location.pathname
    path = path.slice(1, 3);
    if (path === 'en') {
      require("./home.css");
    } else if (path === 'sc') {
      require("./home_sc.css");
    } else if (path === 'tc') {
      require("./home_tc.css");
    }

    document.getElementById('topVideo').loop = true;
    document.getElementById('topVideo').muted = true;
    document.getElementById('topVideo').autoPlay = true;
    document.getElementById('topVideo').pause();

    let myModal = document.getElementById('myModal');
    let video = document.getElementById('video');

    myModal.addEventListener('hide.bs.modal', function () {
      video.setAttribute('src', '');
    });
    setInterval(() => {
      if (this.state.slided) {
      } else {
        let currentPath = window.location.pathname;
        currentPath = currentPath.slice(4, -1);

        if (currentPath === "home" || currentPath === "hom") {
          document.getElementById('first_click').click();

          let path = window.location.pathname
          path = path.slice(1, 3);
          if (path === 'en') {
            this.setState({ topVideoUrl: "https://storage.googleapis.com/emsd_video/Top%20Teaser_EN_6s.mp4?autoPlay=1&loop=1&showinfo=0&controls=0" });
          } else if (path === 'sc') {
            this.setState({ topVideoUrl: "https://storage.googleapis.com/emsd_video/Top%20Teaser_SC.mp4" });
          } else if (path === 'tc') {
            this.setState({ topVideoUrl: "https://storage.googleapis.com/emsd_video/Top%20Teaser_TC.mp4" });
          }
          document.getElementById('topVideo').play();

          this.setState({ slided: true });
        }
      }
    }, 4000)
    document.addEventListener('scroll', () => {
      let currentPath = window.location.pathname;
      currentPath = currentPath.slice(4, -1);

      if (currentPath === "home" || currentPath === "hom") {
        let offset = document.getElementById("news").offsetHeight;
        if (window.scrollY > offset) {
          document.getElementById('topVideo').pause();
        }
      }
    });

  }
  render() {
    const { t } = this.props;
    const { topVideoUrl, topVideoUpdate } = this.state;
    let path = window.location.pathname
    let match = path.slice(0, 3);
    return (
      <div className="d-flex justify-content-center">
        <MetaTags>
          <title>{t('home-meta-title')}</title>
          <meta name="title" content={t('home-meta-title')} />
          <meta name="description" content={t('home-meta-description')} />
          <meta name="keywords" content={t('home-meta-keywords')} />
        </MetaTags>
        <div id="home">

          <div id="intro" className="carousel" data-bs-interval="false">
            <div className="carousel-indicators">
              <button id="zero_click" type="button" data-bs-target="#intro" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
              <button id="first_click" type="button" data-bs-target="#intro" data-bs-slide-to="1" aria-label="Slide 2"></button>
            </div>
            <div className="carousel-inner">
              <div className="carousel-item active carousel-item-1">
                <div className="carousel-caption d-block">
                  <img src={t('carousel-logo')} className="d-block carousel-logo-1" alt="" />
                  <p className="caption-text">{t('Banner msg')}</p>
                  <Link className="no_border" onClick={() => this.goToTop()} to={match + "/about"}><button className="btn_cha"><strong>{t('Learn More')}</strong></button></Link>
                </div>
              </div>
              <div className="carousel-item carousel-item-2 d-flex align-items-center" onClick={() => this.updateTopVideo()}>
                <div className={topVideoUpdate ? "d-none" : "d-flex justify-content-center div-btn_watch"}>
                  <button className={t('btn_watch')}><strong>{t('Watch the Full Video')}</strong></button>
                </div>
                <video autoPlay loop muted playsInline id="topVideo" src={topVideoUrl} type="video/mp4" className={topVideoUpdate ? "carousel-video updated" : "carousel-video"}>
                </video>
              </div>
            </div>
          </div>
          <div id="news">
            <div className="container-fluid d-flex align-items-stretch">
              <div className="col-1 d-none d-lg-block"></div>
              <div className="col-1 col-lg-4 news-headline-box-outer">
                <div className="news-headline-box">
                  <div className={t('news-headline-1 px-4 TXT_medium')}>
                    <span>{t('LATEST')}</span><br /><span>{t('NEWS')}</span>
                  </div>
                  <div className={t('news-headline-2 px-4 TXT_medium')}>
                    <span>{t('LATEST NEWS')}</span>
                  </div>
                </div>
              </div>
              <div className="col-11 col-lg-6 newsbox">
                <div className="newsbox-content">
                  <div className="py-2">
                    <p className={t('newsbox-date pb-1 TXT_bold')}>{t('news-date-7')}</p>
                    <p className="newsbox-msg col-11">{t('news-msg-7-1')}<Link to={match + "/awardsceremony"}>{t('here')}</Link>{t('news-msg-7-2')}</p>
                  </div>
                  <div className="py-2">
                    <p className={t('newsbox-date pb-1 TXT_bold')}>{t('news-date-6')}</p>
                    <p className="newsbox-msg col-11">{t('news-msg-6-1')}<Link to={match + "/competition/#Results"}>{t('here')}</Link>{t('news-msg-6-2')}</p>
                  </div>
                  <div className="py-2">
                    <p className={t('newsbox-date pb-1 TXT_bold')}>{t('news-date-5')}</p>
                    <p className="newsbox-msg col-11">{t('news-msg-5-1')}</p>
                  </div>
                  <div className="py-2">
                    <p className={t('newsbox-date pb-1 TXT_bold')}>{t('news-date-4')}</p>
                    <p className="newsbox-msg col-11">{t('news-msg-4-1')}</p>
                  </div>
                  <div className="py-2">
                    <p className={t('newsbox-date pb-1 TXT_bold')}>{t('news-date-3')}</p>
                    <p className="newsbox-msg col-11">{t('news-msg-3-1')}{t('here')}{t('news-msg-3-2')}</p>
                  </div>
                  <div className="py-2">
                    <p className={t('newsbox-date pb-1 TXT_bold')}>{t('news-date-2')}</p>
                    <p className="newsbox-msg col-11">{t('news-msg-2-1')}<Link to={match + "/conference#programme"}>{t('here')}</Link>{t('news-msg-2-2')}</p>
                  </div>
                  <div className="py-2">
                    <p className={t('newsbox-date pb-1 TXT_bold')}>{t('news-date-1')}</p>
                    <p className="newsbox-msg col-11">{t('news-msg-1')} {t('join now')}</p>
                  </div>
                </div>
              </div>
              <div className="col-1 d-none d-lg-block"></div>
            </div>

          </div>
          <div id="hear-org">
            <div className="container-fluid d-flex align-items-stretch">
              <div className="col-1 d-none d-lg-block say-icon-movie"></div>
              <div className="col-1 col-lg-4 hear-org-headline-box d-lg-flex align-items-center">
                <div className={t('hear-org-headline-md-text TXT_medium')}>
                  <span>{t('HEAR WHAT OUR')}</span> <div className={t('hear-org-headline-lg-text')}>{t('ORGANISERS')}</div> <div className={t('hear-org-headline-sm-text')}>{t('SAY')}</div>
                </div>
              </div>
              <div className="col-10 col-lg-6 d-flex justify-content-center hear-org-gp-outer">
                <div className="col-6 col-lg-5 mt-3 mb-3 d-flex justify-content-center d-lg-block hear-org-gp-inner">
                  <div>
                    <div className="d-flex d-lg-block justify-content-center">
                      <div className="mt-4 org-img-1 org-img d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('org_1')}>
                        <div className="d-flex align-items-center">
                          <img src={say_play_btn} className="say_play_btn" alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="text-center text-lg-start org-info">
                      <div className={t('TXT_bold org-name')}>{t('org-name-1')}</div>
                      <div className={t('title-company-swap')}>
                        <div className="org-title">{t('org-title-1')}</div>
                        <div className={t('TXT_bold org-company')}>{t('org-company-1')}</div>
                      </div>
                    </div>

                  </div>
                </div>
                <div className="col-1 col-lg-2"></div>
                <div className="col-6 col-lg-5 mt-3 mb-3 d-flex justify-content-center d-lg-block hear-org-gp-inner">
                  <div>
                    <div className="d-flex d-lg-block justify-content-center">
                      <div className="mt-4 org-img-2 org-img d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('org_2')}>
                        <div className="d-flex align-items-center">
                          <img src={say_play_btn} className="say_play_btn" alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="text-center text-lg-start org-info">
                      <div className={t('TXT_bold org-name')}>{t('org-name-2')}</div>
                      <div className={t('title-company-swap')}>
                        <div className="org-title">{t('org-title-2')}</div>
                        <div className={t('TXT_bold org-company')}>{t('org-company-2')}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-1 d-block d-lg-none say-icon-movie"></div>
            </div>
          </div>
          <div id="hear-adv">
            <div className="container-fluid d-flex align-items-stretch">
              <div className="d-block d-lg-none col-1 hear-org-headline-box">
                <div className={t('hear-org-headline-md-text TXT_medium')}>
                  {t('HEAR WHAT OUR')} <div className={t('hear-org-headline-lg-text')}>{t('ADVISORS')}</div> <div className={t('hear-org-headline-sm-text')}>{t('SAY')}</div>
                </div>
              </div>
              <div className="d-none d-lg-block col-1"></div>
              <div className="col-10 col-lg-6 d-flex justify-content-center hear-org-gp-outer">
                <div className="col-6 col-lg-5 mt-3 mb-3 d-flex justify-content-center d-lg-block hear-org-gp-inner">
                  <div>
                    <div className="d-flex d-lg-block justify-content-center">
                      <div className="mt-4 adv-img-1 org-img d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('adv_1')}>
                        <div className="d-flex align-items-center">
                          <img src={say_play_btn} className="say_play_btn" alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="text-center text-lg-start org-info-sp">
                      <div className={t('TXT_bold org-name')}>{t('adv-name-1')}</div>
                      <div className={t('title-company-swap')}>
                        <div className="org-title">{t('adv-title-1')}</div>
                        <div className="mt-0">
                          <div className={t('TXT_bold org-company')}>{t('adv-company-1')}</div>
                          <div className={t('TXT_bold org-company')}>{t('adv-company-1-2')}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-1 col-lg-2"></div>
                <div className="col-6 col-lg-5 mt-3 mb-3 d-flex justify-content-center d-lg-block hear-org-gp-inner">
                  <div>
                    <div className="d-flex d-lg-block justify-content-center">
                      <div className="mt-4 adv-img-2 org-img d-flex justify-content-center video-btn" data-bs-toggle="modal" data-bs-target="#myModal" role="button" onClick={() => this.updateVideo('adv_2')}>
                        <div className="d-flex align-items-center">
                          <img src={say_play_btn} className="say_play_btn" alt="" />
                        </div>
                      </div>
                    </div>
                    <div className="text-center text-lg-start org-info">
                      <div className={t('TXT_bold org-name')}>{t('adv-name-2')}</div>
                      <div className={t('title-company-swap')}>
                        <div className="org-title">{t('adv-title-2')}</div>
                        <div className="mt-0">
                          <div className={t('TXT_bold org-company')}>{t('adv-company-2')}</div>
                          <div className={t('TXT_bold org-company')}>{t('adv-company-2-2')}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-4 hear-adv-headline-box d-none d-lg-flex align-items-center">
                <div className={t('hear-org-headline-md-text')}>
                  <strong>{t('HEAR WHAT OUR')} <div className={t('hear-org-headline-lg-text')}>{t('ADVISORS')}</div> <div className={t('hear-org-headline-sm-text')}>{t('SAY')}</div></strong>
                </div>
              </div>
              <div className="col-1 d-none d-lg-block say-icon-movie say-icon-movie-adv"></div>

              <div className="col-1 d-block d-lg-none say-icon-movie"></div>
            </div>
          </div>
          <Rolling />

          <div id="conf" className="d-flex align-items-center justify-content-center">
            <div className="container-fluid d-flex">
              <div className="d-none d-lg-block col-1"></div>
              <div className="d-none d-lg-block col-3">
                <div className="d-flex justify-content-center pb-3">
                  <img src={conf_icon} className="conf-comp-icon" alt="" />
                </div>
                <div className="d-flex justify-content-center pt-3">
                  {/* <Timer date="10/12/2021 09:30 GMT+8" type="conf" /> */}
                </div>
              </div>
              <div className="d-none d-lg-block col-1"></div>
              <div className="col-lg-6 my-lg-5">
                <div className="d-flex">
                  <div className="conf-comp-headline col-7 col-lg-12">
                    <div className={t('conf-comp-headline-2 TXT_medium')}>{t('GLOBAL CONFERENCE')}</div><br />
                    <div className={t('d-none d-lg-block TXT_bold conf-comp-headline-4 conf-headline-date conf-comp-headline-date conf-headline-date-border')}>{t('conf-headline-date')}</div>
                  </div>
                  <div className="col-1 d-lg-none"></div>
                  <div className="col-4 d-lg-none d-flex justify-content-end">
                    <img src={conf_icon} className="conf-comp-icon" alt="" />
                  </div>
                </div>
                <div className={t('d-flex justify-content-center comp-headline-date-mobile')}>
                  <div>
                    <div className={t('d-block d-lg-none TXT_bold conf-comp-headline-4 conf-headline-date conf-comp-headline-date conf-headline-date-border')}>{t('conf-headline-date')}</div>
                  </div>
                </div>

                <div className="d-lg-none d-flex justify-content-center">
                  {/* <Timer date="10/12/2021 09:30 GMT+8" type="conf" /> */}
                </div>
                <div className="conf-text">
                  {t('conf-caption')}
                </div>
                <div className="d-flex">
                  <Link to={match + "/conference#programme"} className="no_border"><button className="btn_conf_comp_sp btn_JnConf"><strong>{t('Get Your Free Pass Now')}</strong></button></Link>
                  <Link className="no_border" onClick={() => this.goToTop()} to={match + "/conference"}><button className="btn_conf_comp_sp btn_cha"><strong>{t('Learn More')}</strong></button></Link>
                </div>
              </div>
              <div className="d-none d-lg-block col-1"></div>
            </div>
          </div>
          <div id="comp" className="d-flex align-items-center justify-content-center">
            <div className="container-fluid d-flex">
              <div className="d-none d-lg-block col-1"></div>
              <div className="col-lg-6 my-lg-5">
                <div className="d-flex">
                  <div className="conf-comp-headline col-7 col-lg-12">
                    <div className={t('conf-comp-headline-2 TXT_medium')}>{t('AI COMPETITION')}</div><br />
                    <div className={t('d-none d-lg-block TXT_bold conf-comp-headline-3 comp-headline-date')}>{t('comp-headline-date-1')}</div>
                    <div className={t('d-none d-lg-block TXT_bold conf-comp-headline-4 comp-headline-date comp-headline-date-border conf-comp-headline-date')}>{t('comp-headline-date-2')}</div>
                  </div>
                  <div className="col-1 d-lg-none"></div>
                  <div className="col-4 d-lg-none d-flex justify-content-end">
                    <img src={comp_icon} className="conf-comp-icon" alt="" />
                  </div>
                </div>
                <div className={t('d-block d-lg-none TXT_bold conf-comp-headline-3 comp-headline-date text-center')}>{t('comp-headline-date-1')}</div>
                <div className="d-flex justify-content-center comp-headline-date-mobile">
                  <div>
                    <div className={t('d-block d-lg-none TXT_bold conf-comp-headline-4 comp-headline-date comp-headline-date-border conf-comp-headline-date')}>{t('comp-headline-date-2')}</div>
                  </div>
                </div>
                <div className="d-lg-none d-flex justify-content-center">
                  {/* <Timer date="11/21/2021 23:59 GMT+8" type="comp" /> */}
                </div>
                <div className="comp-text">
                  {t('comp-caption')}
                </div>
                <div className="d-flex">
                  {/* <a href={t('reg-comp-link')} target="_blank" rel="noopener noreferrer" className="no_border"><button className="btn_conf_comp btn_JnComp"><strong>{t('Join the Competition')}</strong></button></a> */}
                  <Link className="no_border" onClick={() => this.goToTop()} to={match + "/competition"}><button className="btn_conf_comp btn_cha"><strong>{t('Learn More')}</strong></button></Link>
                </div>
              </div>
              <div className="d-none d-lg-block col-1"></div>
              <div className="d-none d-lg-block col-3">
                <div className="d-flex justify-content-center pb-3">
                  <img src={comp_icon} className="conf-comp-icon" alt="" />
                </div>
                <div className="d-flex justify-content-center pt-3">
                  {/* <Timer date="11/21/2021 23:59 GMT+8" type="comp" /> */}
                </div>
              </div>
              <div className="d-none d-lg-block col-1"></div>
            </div>
          </div>
          <div id="sponsor">
            <div className="container-fluid d-flex">
              <div className="col-12">
                <div className={t('sponsor-headline TXT_medium')}>{t('OUR PARTNERS')}</div>
                <div className="div-sponsor">
                  <div className={t('sponsor-title TXT_bold')}><div>{t('Organisers')}</div></div>
                  <div className="d-inline-block">
                    <a href={t('org-link-1')} target="_blank" rel="noopener noreferrer"><img src={org_1} className="sponsor-icon-xl" alt=""></img></a>
                    <img src={org_2} className="sponsor-icon-xl" alt=""></img>
                  </div>
                </div>
                <div className="div-sponsor">
                  <div className={t('sponsor-title TXT_bold')}><div>{t('Advisors')}</div></div>
                  <div className="d-inline-block">
                    <a href={t('adv-link-1')} target="_blank" rel="noopener noreferrer"><img src={adv_1} className="sponsor-icon-xl" alt=""></img></a>
                    <img src={adv_2} className="sponsor-icon-xl" alt=""></img>
                  </div>
                </div>
                <div className="div-sponsor">
                  <div className={t('sponsor-title TXT_bold')}><div>{t('Co-Organisers')}</div></div>
                  <div className="d-none d-xl-inline-block">
                    <div className="d-flex">
                      <a href={t('coorg-link-11')} target="_blank" rel="noopener noreferrer"><img src={coorg_11} className="sponsor-icon-lg" alt=""></img></a>
                      <a href={t('coorg-link-1')} target="_blank" rel="noopener noreferrer"><img src={coorg_1} className="sponsor-icon-lg" alt=""></img></a>
                      <a href={t('coorg-link-2')} target="_blank" rel="noopener noreferrer"><img src={coorg_2} className="sponsor-icon-lg" alt=""></img></a>
                      <a href={t('coorg-link-3')} target="_blank" rel="noopener noreferrer"><img src={coorg_3} className="sponsor-icon-lg sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('coorg-link-4')} target="_blank" rel="noopener noreferrer"><img src={coorg_4} className="sponsor-icon-lg" alt=""></img></a>
                      <a href={t('coorg-link-5')} target="_blank" rel="noopener noreferrer"><img src={coorg_5} className="sponsor-icon-lg" alt=""></img></a>
                      <a href={t('coorg-link-6')} target="_blank" rel="noopener noreferrer"><img src={coorg_6} className="sponsor-icon-lg" alt=""></img></a>
                      <a href={t('coorg-link-7')} target="_blank" rel="noopener noreferrer"><img src={coorg_7} className="sponsor-icon-lg sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('coorg-link-13')} target="_blank" rel="noopener noreferrer"><img src={coorg_13} className="sponsor-icon-lg" alt=""></img></a>
                      <a href={t('coorg-link-8')} target="_blank" rel="noopener noreferrer"><img src={coorg_8} className="sponsor-icon-lg" alt=""></img></a>
                      <a href={t('coorg-link-9')} target="_blank" rel="noopener noreferrer"><img src={coorg_9} className="sponsor-icon-lg" alt=""></img></a>
                      <a href={t('coorg-link-10')} target="_blank" rel="noopener noreferrer"><img src={coorg_10} className="sponsor-icon-lg sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('coorg-link-12')} target="_blank" rel="noopener noreferrer"><img src={coorg_12} className="sponsor-icon-lg sponsor-icon-end" alt=""></img></a>
                    </div>
                  </div>
                  <div className="d-inline-block d-xl-none">
                    <div className="d-flex">
                      <a href={t('coorg-link-11')} target="_blank" rel="noopener noreferrer"><img src={coorg_11} className="sponsor-icon-lg" alt=""></img></a>
                      <a href={t('coorg-link-1')} target="_blank" rel="noopener noreferrer"><img src={coorg_1} className="sponsor-icon-lg" alt=""></img></a>
                      <a href={t('coorg-link-2')} target="_blank" rel="noopener noreferrer"><img src={coorg_2} className="sponsor-icon-lg sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('coorg-link-3')} target="_blank" rel="noopener noreferrer"><img src={coorg_3} className="sponsor-icon-lg" alt=""></img></a>
                      <a href={t('coorg-link-4')} target="_blank" rel="noopener noreferrer"><img src={coorg_4} className="sponsor-icon-lg" alt=""></img></a>
                      <a href={t('coorg-link-5')} target="_blank" rel="noopener noreferrer"><img src={coorg_5} className="sponsor-icon-lg sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('coorg-link-6')} target="_blank" rel="noopener noreferrer"><img src={coorg_6} className="sponsor-icon-lg" alt=""></img></a>
                      <a href={t('coorg-link-7')} target="_blank" rel="noopener noreferrer"><img src={coorg_7} className="sponsor-icon-lg" alt=""></img></a>
                      <a href={t('coorg-link-13')} target="_blank" rel="noopener noreferrer"><img src={coorg_13} className="sponsor-icon-lg sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('coorg-link-8')} target="_blank" rel="noopener noreferrer"><img src={coorg_8} className="sponsor-icon-lg" alt=""></img></a>
                      <a href={t('coorg-link-9')} target="_blank" rel="noopener noreferrer"><img src={coorg_9} className="sponsor-icon-lg" alt=""></img></a>
                      <a href={t('coorg-link-10')} target="_blank" rel="noopener noreferrer"><img src={coorg_10} className="sponsor-icon-lg sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('coorg-link-12')} target="_blank" rel="noopener noreferrer"><img src={coorg_12} className="sponsor-icon-lg sponsor-icon-end" alt=""></img></a>
                    </div>
                  </div>
                </div>
                <div className="div-sponsor">
                  <div className={t('sponsor-title TXT_bold')}><div>{t('Supporting Organisations')}</div></div>
                  <div className="d-none d-xl-inline-block">
                    <div className="d-flex">
                      <a href={t('sup-link-1')} target="_blank" rel="noopener noreferrer"><img src={sup_1} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-2')} target="_blank" rel="noopener noreferrer"><img src={sup_2} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-3')} target="_blank" rel="noopener noreferrer"><img src={sup_3} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-4')} target="_blank" rel="noopener noreferrer"> <img src={sup_4} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-5')} target="_blank" rel="noopener noreferrer"><img src={sup_5} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-6')} target="_blank" rel="noopener noreferrer"><img src={sup_6} className="sponsor-icon sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('sup-link-7')} target="_blank" rel="noopener noreferrer"><img src={sup_7} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-8')} target="_blank" rel="noopener noreferrer"><img src={sup_8} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-9')} target="_blank" rel="noopener noreferrer"><img src={sup_9} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-10')} target="_blank" rel="noopener noreferrer"><img src={sup_10} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-30')} target="_blank" rel="noopener noreferrer"><img src={sup_30} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-11')} target="_blank" rel="noopener noreferrer"><img src={sup_11} className="sponsor-icon sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('sup-link-12')} target="_blank" rel="noopener noreferrer"><img src={sup_12} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-13')} target="_blank" rel="noopener noreferrer"> <img src={sup_13} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-14')} target="_blank" rel="noopener noreferrer"> <img src={sup_14} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-15')} target="_blank" rel="noopener noreferrer"> <img src={sup_15} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-16')} target="_blank" rel="noopener noreferrer"> <img src={sup_16} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-17')} target="_blank" rel="noopener noreferrer"><img src={sup_17} className="sponsor-icon sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('sup-link-18')} target="_blank" rel="noopener noreferrer"><img src={sup_18} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-19')} target="_blank" rel="noopener noreferrer"> <img src={sup_19} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-20')} target="_blank" rel="noopener noreferrer"><img src={sup_20} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-21')} target="_blank" rel="noopener noreferrer"><img src={sup_21} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-22')} target="_blank" rel="noopener noreferrer"><img src={sup_22} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-23')} target="_blank" rel="noopener noreferrer"><img src={sup_23} className="sponsor-icon sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('sup-link-24')} target="_blank" rel="noopener noreferrer"><img src={sup_24} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-25')} target="_blank" rel="noopener noreferrer"><img src={sup_25} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-31')} target="_blank" rel="noopener noreferrer"><img src={sup_31} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-26')} target="_blank" rel="noopener noreferrer"><img src={sup_26} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-27')} target="_blank" rel="noopener noreferrer"><img src={sup_27} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-28')} target="_blank" rel="noopener noreferrer"><img src={sup_28} className="sponsor-icon sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('sup-link-29')} target="_blank" rel="noopener noreferrer"><img src={sup_29} className="sponsor-icon sponsor-icon-end" alt=""></img></a>
                    </div>
                  </div>

                  <div className="d-inline-block d-xl-none">
                    <div className="d-flex">
                      <a href={t('sup-link-1')} target="_blank" rel="noopener noreferrer"><img src={sup_1} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-2')} target="_blank" rel="noopener noreferrer"><img src={sup_2} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-3')} target="_blank" rel="noopener noreferrer"><img src={sup_3} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-4')} target="_blank" rel="noopener noreferrer"><img src={sup_4} className="sponsor-icon sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('sup-link-5')} target="_blank" rel="noopener noreferrer"><img src={sup_5} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-6')} target="_blank" rel="noopener noreferrer"><img src={sup_6} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-7')} target="_blank" rel="noopener noreferrer"> <img src={sup_7} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-8')} target="_blank" rel="noopener noreferrer"><img src={sup_8} className="sponsor-icon sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('sup-link-9')} target="_blank" rel="noopener noreferrer"><img src={sup_9} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-10')} target="_blank" rel="noopener noreferrer"> <img src={sup_10} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-30')} target="_blank" rel="noopener noreferrer"><img src={sup_30} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-11')} target="_blank" rel="noopener noreferrer"><img src={sup_11} className="sponsor-icon sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('sup-link-12')} target="_blank" rel="noopener noreferrer"> <img src={sup_12} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-13')} target="_blank" rel="noopener noreferrer"><img src={sup_13} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-14')} target="_blank" rel="noopener noreferrer"> <img src={sup_14} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-15')} target="_blank" rel="noopener noreferrer"> <img src={sup_15} className="sponsor-icon sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('sup-link-16')} target="_blank" rel="noopener noreferrer"><img src={sup_16} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-17')} target="_blank" rel="noopener noreferrer"><img src={sup_17} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-18')} target="_blank" rel="noopener noreferrer"><img src={sup_18} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-19')} target="_blank" rel="noopener noreferrer"><img src={sup_19} className="sponsor-icon sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('sup-link-20')} target="_blank" rel="noopener noreferrer"> <img src={sup_20} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-21')} target="_blank" rel="noopener noreferrer"> <img src={sup_21} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-22')} target="_blank" rel="noopener noreferrer"> <img src={sup_22} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-23')} target="_blank" rel="noopener noreferrer"><img src={sup_23} className="sponsor-icon sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('sup-link-24')} target="_blank" rel="noopener noreferrer"><img src={sup_24} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-25')} target="_blank" rel="noopener noreferrer"><img src={sup_25} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-31')} target="_blank" rel="noopener noreferrer"><img src={sup_31} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-26')} target="_blank" rel="noopener noreferrer"> <img src={sup_26} className="sponsor-icon sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('sup-link-27')} target="_blank" rel="noopener noreferrer"><img src={sup_27} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-28')} target="_blank" rel="noopener noreferrer"><img src={sup_28} className="sponsor-icon" alt=""></img></a>
                      <a href={t('sup-link-29')} target="_blank" rel="noopener noreferrer"><img src={sup_29} className="sponsor-icon sponsor-icon-end" alt=""></img></a>
                    </div>
                  </div>
                </div>
                <div className="div-sponsor">
                  <div className={t('sponsor-title TXT_bold')}><div>{t('Diamond Sponsors')}</div></div>
                  <div className="d-none d-xl-inline-block">
                    <div className="d-flex">
                      <a href={t('dia-link-1')} target="_blank" rel="noopener noreferrer"><img src={dia_1} className="sponsor-icon-lg-2" alt=""></img></a>
                      <a href={t('dia-link-2')} target="_blank" rel="noopener noreferrer"><img src={dia_3} className="sponsor-icon-lg-2" alt=""></img></a>
                      <a href={t('dia-link-3')} target="_blank" rel="noopener noreferrer"><img src={dia_2} className="sponsor-icon-lg-2" alt=""></img></a>
                      <a href={t('dia-link-4')} target="_blank" rel="noopener noreferrer"><img src={dia_4} className="sponsor-icon-lg-2 sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('dia-link-5')} target="_blank" rel="noopener noreferrer"><img src={dia_5} className="sponsor-icon-lg-2" alt=""></img></a>
                      <a href={t('dia-link-6')} target="_blank" rel="noopener noreferrer"><img src={dia_6} className="sponsor-icon-lg-2" alt=""></img></a>
                      <a href={t('dia-link-7')} target="_blank" rel="noopener noreferrer"><img src={dia_7} className="sponsor-icon-lg-2" alt=""></img></a>
                      <a href={t('dia-link-8')} target="_blank" rel="noopener noreferrer"><img src={dia_8} className="sponsor-icon-lg-2 sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('dia-link-9')} target="_blank" rel="noopener noreferrer"><img src={dia_9} className="sponsor-icon-lg-2" alt=""></img></a>
                      <a href={t('dia-link-10')} target="_blank" rel="noopener noreferrer"><img src={dia_10} className="sponsor-icon-lg-2" alt=""></img></a>
                      <a href={t('dia-link-11')} target="_blank" rel="noopener noreferrer"><img src={dia_11} className="sponsor-icon-lg-2 sponsor-icon-end" alt=""></img></a>
                    </div>
                  </div>
                  <div className="d-inline-block d-xl-none">
                    <div className="d-flex">
                      <a href={t('dia-link-1')} target="_blank" rel="noopener noreferrer"><img src={dia_1} className="sponsor-icon-lg-2" alt=""></img></a>
                      <a href={t('dia-link-2')} target="_blank" rel="noopener noreferrer"><img src={dia_3} className="sponsor-icon-lg-2" alt=""></img></a>
                      <a href={t('dia-link-3')} target="_blank" rel="noopener noreferrer"><img src={dia_2} className="sponsor-icon-lg-2 sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('dia-link-4')} target="_blank" rel="noopener noreferrer"> <img src={dia_4} className="sponsor-icon-lg-2" alt=""></img></a>
                      <a href={t('dia-link-5')} target="_blank" rel="noopener noreferrer"><img src={dia_5} className="sponsor-icon-lg-2" alt=""></img></a>
                      <a href={t('dia-link-6')} target="_blank" rel="noopener noreferrer"> <img src={dia_6} className="sponsor-icon-lg-2 sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('dia-link-7')} target="_blank" rel="noopener noreferrer"> <img src={dia_7} className="sponsor-icon-lg-2" alt=""></img></a>
                      <a href={t('dia-link-8')} target="_blank" rel="noopener noreferrer"> <img src={dia_8} className="sponsor-icon-lg-2" alt=""></img></a>
                      <a href={t('dia-link-9')} target="_blank" rel="noopener noreferrer"> <img src={dia_9} className="sponsor-icon-lg-2 sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('dia-link-10')} target="_blank" rel="noopener noreferrer"> <img src={dia_10} className="sponsor-icon-lg-2" alt=""></img></a>
                      <a href={t('dia-link-11')} target="_blank" rel="noopener noreferrer"> <img src={dia_11} className="sponsor-icon-lg-2 sponsor-icon-end" alt=""></img></a>
                    </div>
                  </div>
                </div>
                <div className="div-sponsor">
                  <div className={t('sponsor-title TXT_bold')}><div>{t('Platinum Sponsors')}</div></div>
                  <div className="d-none d-xl-inline-block">
                    <div className="d-flex">
                      <a href={t('plat-link-1')} target="_blank" rel="noopener noreferrer"><img src={plat_1} className="sponsor-icon-lg-3" alt=""></img></a>
                      <a href={t('plat-link-2')} target="_blank" rel="noopener noreferrer"> <img src={plat_2} className="sponsor-icon-lg-3" alt=""></img></a>
                      <a href={t('plat-link-13')} target="_blank" rel="noopener noreferrer"> <img src={plat_13} className="sponsor-icon-lg-3" alt=""></img></a>
                      <a href={t('plat-link-3')} target="_blank" rel="noopener noreferrer"><img src={plat_3} className="sponsor-icon-lg-3 sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('plat-link-4')} target="_blank" rel="noopener noreferrer"><img src={plat_4} className="sponsor-icon-lg-3" alt=""></img></a>
                      <a href={t('plat-link-5')} target="_blank" rel="noopener noreferrer"><img src={plat_5} className="sponsor-icon-lg-3" alt=""></img></a>
                      <img src={plat_6} className="sponsor-icon-lg-3" alt=""></img>
                      <a href={t('plat-link-7')} target="_blank" rel="noopener noreferrer"><img src={plat_7} className="sponsor-icon-lg-3 sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('plat-link-8')} target="_blank" rel="noopener noreferrer"><img src={plat_8} className="sponsor-icon-lg-3" alt=""></img></a>
                      <a href={t('plat-link-9')} target="_blank" rel="noopener noreferrer"> <img src={plat_9} className="sponsor-icon-lg-3" alt=""></img></a>
                      <a href={t('plat-link-10')} target="_blank" rel="noopener noreferrer"> <img src={plat_10} className="sponsor-icon-lg-3" alt=""></img></a>
                      <a href={t('plat-link-11')} target="_blank" rel="noopener noreferrer"><img src={plat_11} className="sponsor-icon-lg-3 sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('plat-link-12')} target="_blank" rel="noopener noreferrer"><img src={plat_12} className="sponsor-icon-lg-3 sponsor-icon-end" alt=""></img></a>
                    </div>
                  </div>
                  <div className="d-inline-block d-xl-none">
                    <div className="d-flex">
                      <a href={t('plat-link-1')} target="_blank" rel="noopener noreferrer"><img src={plat_1} className="sponsor-icon-lg-3" alt=""></img></a>
                      <a href={t('plat-link-2')} target="_blank" rel="noopener noreferrer"><img src={plat_2} className="sponsor-icon-lg-3" alt=""></img></a>
                      <a href={t('plat-link-13')} target="_blank" rel="noopener noreferrer"> <img src={plat_13} className="sponsor-icon-lg-3 sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('plat-link-3')} target="_blank" rel="noopener noreferrer"><img src={plat_3} className="sponsor-icon-lg-3" alt=""></img></a>
                      <a href={t('plat-link-4')} target="_blank" rel="noopener noreferrer"><img src={plat_4} className="sponsor-icon-lg-3" alt=""></img></a>
                      <a href={t('plat-link-5')} target="_blank" rel="noopener noreferrer"> <img src={plat_5} className="sponsor-icon-lg-3 sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <img src={plat_6} className="sponsor-icon-lg-3" alt=""></img>
                      <a href={t('plat-link-7')} target="_blank" rel="noopener noreferrer"><img src={plat_7} className="sponsor-icon-lg-3" alt=""></img></a>
                      <a href={t('plat-link-8')} target="_blank" rel="noopener noreferrer"> <img src={plat_8} className="sponsor-icon-lg-3 sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('plat-link-9')} target="_blank" rel="noopener noreferrer"> <img src={plat_9} className="sponsor-icon-lg-3" alt=""></img></a>
                      <a href={t('plat-link-10')} target="_blank" rel="noopener noreferrer"> <img src={plat_10} className="sponsor-icon-lg-3" alt=""></img></a>
                      <a href={t('plat-link-11')} target="_blank" rel="noopener noreferrer"> <img src={plat_11} className="sponsor-icon-lg-3 sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('plat-link-12')} target="_blank" rel="noopener noreferrer"><img src={plat_12} className="sponsor-icon-lg-3 sponsor-icon-end" alt=""></img></a>
                    </div>
                  </div>
                </div>
                <div className="div-sponsor">
                  <div className={t('sponsor-title TXT_bold')}><div>{t('Gold Sponsors')}</div></div>
                  <div className="d-none d-xl-inline-block">
                    <div className="d-flex">
                      <a href={t('gold-link-8')} target="_blank" rel="noopener noreferrer"> <img src={gold_8} className="sponsor-icon-2" alt=""></img></a>
                      <a href={t('gold-link-1')} target="_blank" rel="noopener noreferrer"> <img src={gold_1} className="sponsor-icon-2" alt=""></img></a>
                      <a href={t('gold-link-2')} target="_blank" rel="noopener noreferrer"> <img src={gold_2} className="sponsor-icon-2" alt=""></img></a>
                      <a href={t('gold-link-3')} target="_blank" rel="noopener noreferrer"><img src={gold_5} className="sponsor-icon-2" alt=""></img></a>
                      <a href={t('gold-link-4')} target="_blank" rel="noopener noreferrer"><img src={gold_3} className="sponsor-icon-2 sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('gold-link-5')} target="_blank" rel="noopener noreferrer"><img src={gold_4} className="sponsor-icon-2" alt=""></img></a>
                      <a href={t('gold-link-7')} target="_blank" rel="noopener noreferrer"><img src={gold_7} className="sponsor-icon-2" alt=""></img></a>
                      <a href={t('gold-link-6')} target="_blank" rel="noopener noreferrer"> <img src={gold_6} className="sponsor-icon-2 sponsor-icon-end" alt=""></img></a>
                    </div>
                  </div>
                  <div className="d-inline-block d-xl-none">
                    <div className="d-flex">
                      <a href={t('gold-link-8')} target="_blank" rel="noopener noreferrer"> <img src={gold_8} className="sponsor-icon-2" alt=""></img></a>
                      <a href={t('gold-link-1')} target="_blank" rel="noopener noreferrer"> <img src={gold_1} className="sponsor-icon-2" alt=""></img></a>
                      <a href={t('gold-link-2')} target="_blank" rel="noopener noreferrer"> <img src={gold_2} className="sponsor-icon-2 sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('gold-link-3')} target="_blank" rel="noopener noreferrer"><img src={gold_5} className="sponsor-icon-2" alt=""></img></a>
                      <a href={t('gold-link-4')} target="_blank" rel="noopener noreferrer"><img src={gold_3} className="sponsor-icon-2" alt=""></img></a>
                      <a href={t('gold-link-5')} target="_blank" rel="noopener noreferrer"> <img src={gold_4} className="sponsor-icon-2 sponsor-icon-end" alt=""></img></a>
                    </div>
                    <div className="d-flex">
                      <a href={t('gold-link-7')} target="_blank" rel="noopener noreferrer"><img src={gold_7} className="sponsor-icon-2" alt=""></img></a>
                      <a href={t('gold-link-6')} target="_blank" rel="noopener noreferrer"><img src={gold_6} className="sponsor-icon-2" alt=""></img></a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Footer />
          {/*  Modal */}
          <div className="modal fade" id="myModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="d-flex justify-content-end">
                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>

                  <div className="ratio ratio-16x9">
                    <video autoPlay playsInline controls src="" id="video">
                      <source src="" type="video/mp4"/>
                    </video>
                    {/* <iframe className="embed-responsive-item" src="" id="video" allowscriptaccess="always" title="Video"></iframe> */}
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>

      </div >



    );
  }
}

// extended main view with translate hoc
export default translate("translations")(Home);



// WEBPACK FOOTER //
// ./src/components/pages/home.js